import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UnauthorizedAccess.css';

const UnauthorizedAccess = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/', { replace: true, state: { from: 'internal' } });
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="unauthorized-icon">
          🔒
        </div>
        <h1>Acceso No Autorizado</h1>
        <p>No tienes permisos para acceder a esta página.</p>
        <p className="redirect-msg">Serás redirigido a la página principal en 5 segundos...</p>
        <button onClick={() => navigate('/', { replace: true, state: { from: 'internal' } })} className="unauthorized-btn">
          Ir a Inicio Ahora
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedAccess;
